


























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Form } from '@/models/Form';
import { ReportElement, Report } from '@/models/ReportElement';
import { BDropdown, BDropdownItem, BOverlay } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import Editor from '@/components/Editor.vue';
import ModalVisibilityRuleSets from '@/components/modals/VisibilityRuleSets.vue';
import ModalReportElementDelete from '@/components/modals/ReportElementDelete.vue';

@Component({
    name: 'CardReportElement',
    components: {
        draggable,
        'editor': Editor,
        'b-overlay': BOverlay,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'modal-visibility-rule-sets': ModalVisibilityRuleSets,
        'modal-form-element-delete': ModalReportElementDelete,
    },
    computed: mapGetters({
        forms: 'forms',
        formElementTags: 'formElementTags/all',
    }),
})
export default class CardReportElement extends Vue {
    updating: boolean = false;
    ruleTarget: ReportElement | null = null;
    collapsed: boolean = true;

    @Prop() form!: Form;
    @Prop() element!: ReportElement;
    @Prop() report!: Report;

    async update() {
        this.updating = true;
        try {
            const element = await this.$store.dispatch('reportElements/update', {
                id: this.element.id,
                title: this.element.title,
                params: this.element.params,
            });
            this.$store.commit('reports/setElement', element);
        } catch (e) {
            // TODO Catch error
        } finally {
            this.updating = false;
        }
    }
}
